import React, { useEffect, useState } from 'react';
import {
  COMPILED_RELEASE_ID,
  verifyReleaseProvenance,
} from '@/lib/releaseProvenance';

export default function ReleaseProvenanceGate({
  children,
  productionMode = process.env.NODE_ENV === 'production',
  expectedReleaseId = COMPILED_RELEASE_ID,
}) {
  const [state, setState] = useState(productionMode ? 'checking' : 'ready');
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!productionMode) {
      setState('ready');
      return undefined;
    }
    let active = true;
    setState('checking');
    verifyReleaseProvenance({ expectedReleaseId })
      .then(() => {
        if (active) setState('ready');
      })
      .catch(() => {
        if (active) setState('failed');
      });
    return () => {
      active = false;
    };
  }, [attempt, expectedReleaseId, productionMode]);

  if (state === 'ready') return children;
  if (state === 'checking') {
    return <main className="min-h-screen p-6" role="status">Verifica versione applicativa…</main>;
  }
  return (
    <main className="min-h-screen p-6 flex flex-col items-center justify-center" role="alert" data-testid="release-provenance-failure">
      <p>La versione dell’app non è allineata al servizio. Controlla la connessione e riprova.</p>
      <button type="button" onClick={() => setAttempt((value) => value + 1)}>
        Riprova
      </button>
    </main>
  );
}
